import { BreadCrumbs } from 'js/toolbar/breadcrumbs';
import { MyIconsDownload } from 'js/toolbar/myIcons';
import { Search } from 'js/toolbar/search';
import { ViewToggle } from 'js/toolbar/viewToggle';
import subCategoryStore from 'js/stores/store';

import React from 'react';

export class Toolbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...subCategoryStore.getState()
    };
    subCategoryStore.subscribe(this.storeUpdated.bind(this));
  }

  storeUpdated() {
    this.setState(subCategoryStore.getState());
  }
  render() {
    const inSubCat = window.location.href.indexOf('subcat') > -1;
    const inSingle = window.location.href.indexOf('single') > -1;
    let toggle;
    if (inSubCat) {
      toggle = <ViewToggle />;
    } else {
      toggle = <div></div>;
    }

    return (
      <div className='toolbar'>
        <div className='flex toolbar--top-tool'>
          <div className='my-icons-download'>
            <MyIconsDownload />
          </div>
          <div className='search'>
            <Search />
          </div>
        </div>
        <div className='flex toolbar--bottom-tool'>
          <div className='bread-crumbs'>
            <BreadCrumbs />
          </div>
          <div className='view-toggle'>{toggle}</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/toolbar/toolbar.js